var buildKBBTradeInObject = tradeInData => {
  const {
    amountOwed,
    condition,
    make,
    mileage,
    model,
    trim,
    value,
    vehicleId,
    year
  } = tradeInData;
  const tradeIn = {
    source: 'KBB'
  };
  if (amountOwed) {
    tradeIn.amountOwed = amountOwed;
  }
  if (condition) {
    tradeIn.condition = condition;
  }
  if (make) {
    tradeIn.make = make;
  }
  if (mileage) {
    tradeIn.mileage = mileage;
  }
  if (model) {
    tradeIn.model = model;
  }
  if (trim) {
    tradeIn.trim = trim;
  }
  if (value) {
    tradeIn.value = value;
  }
  if (vehicleId) {
    tradeIn.vehicleId = Number(vehicleId);
  }
  if (year) {
    tradeIn.year = year;
  }
  return tradeIn;
};
export { buildKBBTradeInObject as default };
